import { render, staticRenderFns } from "./ElPhoneVerifyCodeInput.vue?vue&type=template&id=27cbda6d&scoped=true"
import script from "./ElPhoneVerifyCodeInput.vue?vue&type=script&lang=ts"
export * from "./ElPhoneVerifyCodeInput.vue?vue&type=script&lang=ts"
import style0 from "./ElPhoneVerifyCodeInput.vue?vue&type=style&index=0&id=27cbda6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbda6d",
  null
  
)

export default component.exports